import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "./PrintPhieuPT.scss";
import { Button, Col, Row, Spin } from "antd";
import Sign from "components/common/PrintForm/Sign/Sign";
import ReactToPrint from "react-to-print";
import { useAppSelector } from "redux/hooks";
import { birthday2Age, convertIosStringToDateDayjs } from "helper/common";
import { PPVoCam } from "../SurgeryDetail/config";
import residentialNurseService from "api/residentialNurse";
import Notification from "components/common/notification/notification";
import { getText } from "helper/convertHtmlToText";
import moment from "moment";
import { ImageEyeSVG } from "assets";
import inpatientService from "api/inpatientTreatment";

const PrintPhieuPT = (props) => {
  const printRef = useRef<any>();
  const { closeModal, openModal, id } = props;
  const onPrint = async () => {
    window.print();
  };

  const [ppVoCam, setPPVoCam] = useState(null);
  //tích mắt trái phải
  const [checkedLeft, setCheckedLeft] = useState(false);
  const [checkedRight, setCheckedright] = useState(false);
  const [loading, setLoading] = useState(true);

  const [rooms, setRooms] = useState<any>(
    JSON.parse(localStorage.getItem("phong"))
  );
  const [listDMGiuong, setListDMGiuong] = useState<any>(
    JSON.parse(localStorage.getItem("giuong"))
  );
  const [nameRoom, setNameRoom] = useState<any>();
  //bác sĩ phẫu thuật - phụ bá sĩ phẫu thuật 1 - phụ bác sĩ phẫu thuật 2
  const [surgeryDoctor, setSurgeryDoctor] = useState<any>();

  const [supportSurgeryDoctor2, setSupportSurgeryDoctor2] = useState<any>();
  // const [giuongSo, setGiuongSo] = useState<any>();
  // const id = useAppSelector((e) => e.residentialNurse.id);

  const [patientInfo, setpatientInfo] = useState(null);
  const [patientDetail, setPatientDetail] = useState(null);
  const [surgeryStaff, setSurgeryStaff] = useState([]);
  const [trcPT, settrcPT] = useState(null);
  const [sauPT, setsauPT] = useState(null);
  const [optionsIcd, setOptionsIcd] = useState(null);

  //bác sĩ gây mê
  const [anesthesiologist, setAnesthesiologist] = useState<any>();

  // const patientDetail = useAppSelector((e) => e.residentialNurse.patientDetail);
  const getDiagnoseBeforeSurgery = async () => {
    try {
      const res = await residentialNurseService.getDiagnoseBeforeSurgery();
      const options = res.map((item) => {
        return { value: item.tenIcd, label: item.maIcd } || [];
      });
      setOptionsIcd(options);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách icd");
    }
  };
  // const optionsIcd = useAppSelector((e) => e.residentialNurse.optionICD);

  const listDoctor = useAppSelector((e) => e.residentialNurse.listDoctor);

  const listDmPPPT = useAppSelector((e) => e.residentialNurse.listDmPPPT);

  const clerData = () => {
    setLoading(true);
    setPPVoCam(null);
    setSurgeryDoctor([]);
    setSupportSurgeryDoctor2([]);
    setListDMGiuong([]);
    setpatientInfo(null);
    setPatientDetail(null);
    setSurgeryStaff([]);
    setsauPT(null);
    settrcPT(null);
  };
  useMemo(() => {
    clerData();
  }, [closeModal]);
  useEffect(() => {
    clerData();
    getPatientInfo();
    getLitSurgeryStaff();
    getDetailInfoById();
    getDiagnoseBeforeSurgery();
  }, [openModal]);

  //thông tin bệnh nhân
  const getPatientInfo = async () => {
    try {
      // setLoading(true);
      const res = await residentialNurseService.getPatientInfoById(id);
      setpatientInfo(res);
      // setLoading(false);

      // dispatch(setIdPhieuKham(res.idPhieuKham));
    } catch (error) {
      if (id) {
        Notification("error", "Đã xảy ra lỗi trong khi lấy dữ liệu");
      } else Notification("error", "Không có thông tin phiếu khám");
      // setLoading(false);
    }
  };

  // chi tiết quá trình phẫu thuật
  const getDetailInfoById = async () => {
    if (id !== null) {
      try {
        // setLoading(true);
        const res = await residentialNurseService.getDetailInfoById(id);
        setPatientDetail(res);
        // setLoading(false);
      } catch (error) {
        Notification(
          "error",
          "Đã xảy ra lỗi khi lấy chi tiết thông tin bệnh nhân"
        );
        setLoading(false);
      }
    }
  };

  const getLitSurgeryStaff = async () => {
    try {
      const res = await residentialNurseService.getLitSurgeryStaff();
      setSurgeryStaff(res);
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách nhân sự phẫu thuật"
      );
    }
  };

  useEffect(() => {
    const sauPT = patientDetail?.quaTrinhPhauThuat?.chuanDoanSauPTList;
    if (sauPT && optionsIcd) {
      optionsIcd.find((e) =>
        e.value === sauPT.replace("\n", "") ||
        e.label === sauPT.replace("\n", "")
          ? setsauPT(e)
          : null
      );
    } else setsauPT(null);

    const trcPT = patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTList;
    if (trcPT && optionsIcd) {
      const res = optionsIcd.find((e) => {
        if (
          e.value === trcPT.replace("\n", "") ||
          e.label === trcPT.replace("\n", "")
        ) {
          return e;
        }
      });
      if (res) {
        settrcPT(res);
      } else {
        settrcPT({
          label: patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTList,
          value: patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTValue,
        });
      }
    } else settrcPT("");
  }, [patientDetail, optionsIcd]);

  useEffect(() => {
    if (patientDetail) {
      setLoading(true);
      if (patientDetail?.quaTrinhPhauThuat?.ppVoCam) {
        PPVoCam.find((e) =>
          e.value === patientDetail?.quaTrinhPhauThuat.ppVoCam
            ? setPPVoCam(e)
            : null
        );
      }
      surgeryStaff?.map((item) => {
        if (item.name === "bacSiPhauThuat") {
          if (
            patientDetail?.nhanSuPhauThuat?.bacSiPhauThuat?.list?.length > 0
          ) {
            const res = item.list.find(
              (e) =>
                e.name ===
                patientDetail?.nhanSuPhauThuat?.bacSiPhauThuat?.list[0]
            );
            setSurgeryDoctor(res);
          } else setSurgeryDoctor(null);
        }
        if (item.name === "bacSiGayMe") {
          if (patientDetail?.nhanSuPhauThuat?.bacSiGayMe?.list?.length > 0) {
            const res = item.list.find(
              (e) =>
                e.name === patientDetail?.nhanSuPhauThuat?.bacSiGayMe?.list[0]
            );
            setAnesthesiologist(res);
          } else setAnesthesiologist(null);
        }
        if (item.name === "bacSiPhauThuatPhu") {
          if (
            patientDetail?.nhanSuPhauThuat?.bacSiPhauThuatPhu?.list?.length > 0
          ) {
            item.list.find((e) => {
              if (
                e.name ===
                patientDetail?.nhanSuPhauThuat?.bacSiPhauThuatPhu?.list[0]
              ) {
                setSupportSurgeryDoctor2(e);
              }
            });
          } else setSupportSurgeryDoctor2(null);
        }
      });
      setLoading(false);
    }
  }, [patientDetail, surgeryStaff]);
  const getListDanhMucGiuongBenh = async () => {
    try {
      const params = {
        limit: 10000,
        page: 1,
      };

      const res = await inpatientService.getListDanhMucGiuongBenh(params);

      setListDMGiuong(res.data);
    } catch (error) {}
  };

  const getListBuongSo = async () => {
    const param = {
      page: 1,
      limit: 1000,
    };
    try {
      const res = await inpatientService.getListDanhMucPhongBenh(param);
      setRooms(res.data);
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã xảy ra lỗi khi lấy danh sách buồng");
    }
  };
  useEffect(() => {
    if (rooms?.length == 0 || !rooms) {
      getListBuongSo();
    }
    console.log(listDMGiuong?.length === 0);
    console.log(JSON.parse(localStorage.getItem("giuong")));

    if (!listDMGiuong || listDMGiuong?.length == 0) {
      getListDanhMucGiuongBenh();
    }
  }, [openModal, rooms, listDMGiuong]);

  return (
    <div className="phieu-pt">
      <Spin spinning={loading}>
        <div
          style={{
            padding: "20px 15px 10px 90px",
            // height: "1123px",
            position: "relative",
            margin: "auto",
          }}
          ref={printRef}
        >
          <div>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Row justify={"start"} style={{ fontSize: "12pt" }}>
                  BỘ Y TẾ
                </Row>
                <Row style={{ fontSize: "12pt" }}>
                  BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                </Row>
              </Col>
              <Col span={4}>
                <Row>MS: 14/BV-01</Row>
                <Row>Mã BN: {patientInfo?.maBenhNhan}</Row>
              </Col>
            </Row>
            <Row
              justify={"center"}
              style={{
                fontWeight: "bold",
                padding: "20px",
                fontSize: "24px",
              }}
            >
              PHIẾU PHẪU THUẬT/ THỦ THUẬT
            </Row>
            <Row>
              <Col span={16}>Họ tên bệnh nhân: {patientInfo?.tenBenhNhan}</Col>
              <Col span={4}>Tuổi: {birthday2Age(patientInfo?.ngaySinh)}</Col>
              <Col span={4}>
                Giới tính:{" "}
                {patientInfo?.gioiTinh === 1
                  ? "Nữ"
                  : patientInfo?.gioiTinh === 0
                  ? "Nam"
                  : "--"}
              </Col>
            </Row>
            <Row>Địa chỉ: {patientInfo?.diaChi}</Row>
            <Row>
              <Col span={10}>Khoa: Mắt tổng hợp</Col>
              <Col span={10}>
                Buồng:{" "}
                {rooms.find((e) => e.id === patientDetail?.idBuongSo)?.tenPhong}
              </Col>
              <Col span={4}>
                Giường bệnh:{" "}
                {
                  listDMGiuong.find((e) => e.id === patientDetail?.idGiuongSo)
                    ?.soGiuong
                }
              </Col>
            </Row>
            {patientInfo?.ngayNhapVien ? (
              <Row>
                <Col span={7}>Vào viện lúc:</Col>
                <Col flex={"auto"} style={{ wordSpacing: 12 }}>
                  {moment(patientInfo?.ngayKham).format(
                    "HH   [giờ]    mm [phút],   [ngày] DD [tháng] MM [năm] YYYY"
                  )}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={8}>Vào viện lúc:</Col>
                <Col span={2}>giờ</Col>
                <Col span={3}>phút, ngày</Col>
                <Col span={2}>tháng</Col>
                <Col span={2}>năm</Col>
              </Row>
            )}
            <Row>
              {patientDetail?.quaTrinhPhauThuat?.thoiGianBatDau ? (
                <Fragment>
                  <Col span={7}>PT/ TT bắt đầu lúc:</Col>
                  <Col flex={"auto"} style={{ wordSpacing: 12 }}>
                    {moment(
                      patientDetail?.quaTrinhPhauThuat?.thoiGianBatDau
                    ).format(
                      "HH   [giờ]    mm [phút],   [ngày] DD [tháng] MM [năm] YYYY"
                    ) ||
                      convertIosStringToDateDayjs(
                        patientDetail?.thoiGianBatDau
                      )}
                  </Col>
                </Fragment>
              ) : (
                <Fragment>
                  <Col span={8}>PT/ TT bắt đầu lúc:</Col>
                  <Col span={2}>giờ</Col>
                  <Col span={3}>phút, ngày</Col>
                  <Col span={2}>tháng</Col>
                  <Col span={2}>năm</Col>
                </Fragment>
              )}
              {/* {surgeryDetail?.quaTrinhPhauThuat?.thoiGianKetThuc ? (
                <Fragment>
                  <Col span={6}>Phẫu thuật/ Thủ thuật kết thúc lúc:</Col>
                  <Col span={10}>
                    {moment(
                      surgeryDetail?.quaTrinhPhauThuat?.thoiGianKetThuc
                    ).format(
                      "HH   [giờ]    mm [phút],   [ngày] DD [tháng] MM [năm] YYYY"
                    )}
                  </Col>
                </Fragment>
              ) : (
                <Fragment>
                  <Col span={3}>;Kết thúc lúc:</Col>
                  <Col span={2}>Ngày</Col>
                  <Col span={2}>tháng</Col>
                  <Col span={1}>năm</Col>
                </Fragment>
              )} */}
            </Row>
            {patientDetail?.quaTrinhPhauThuat?.thoiGianKetThuc ? (
              <Row>
                <Col span={7}>Phẫu thuật/ Thủ thuật kết thúc lúc:</Col>
                <Col flex={"auto"} style={{ wordSpacing: 12 }}>
                  {moment(
                    patientDetail?.quaTrinhPhauThuat?.thoiGianKetThuc
                  ).format(
                    "HH   [giờ]    mm [phút],   [ngày] DD [tháng] MM [năm] YYYY"
                  )}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={8}>Phẫu thuật/ Thủ thuật kết thúc lúc:</Col>
                <Col span={2}>giờ</Col>
                <Col span={3}>phút, ngày</Col>
                <Col span={2}>tháng</Col>
                <Col span={2}>năm</Col>
              </Row>
            )}
            <Row>Chẩn đoán:</Row>
            <Row>
              <Col span={2}></Col>
              <Col>
                Trước phẫu thuật/ thủ thuật:{" "}
                {trcPT && ` ${trcPT?.label} - ${trcPT?.value}`}
                {/* {patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTList
                  ? optionsIcd?.find(
                      (e) =>
                        e.value ===
                          patientDetail?.quaTrinhPhauThuat
                            ?.chanDoanTruocPTList ||
                        e.label ===
                          patientDetail?.quaTrinhPhauThuat
                            ?.chanDoanTruocPTList ||
                        e.label ===
                          patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTList.trim()
                    )?.label +
                    " - " +
                    patientDetail?.quaTrinhPhauThuat?.chanDoanTruocPTValue
                  : patientDetail?.icdChanDoan
                  ? patientDetail?.icdChanDoan + " - "
                  : "" + patientDetail?.chanDoan
                  ? patientDetail?.chanDoan
                  : ""} */}
              </Col>
            </Row>
            <Row>
              <Col span={2}></Col>
              <Col>
                Sau phẫu thuật/ thủ thuật:{" "}
                {sauPT && ` ${sauPT?.label} - ${sauPT?.value}`}
                {/* {optionsIcd?.find(
                  (e) =>
                    e.value ===
                    patientDetail?.quaTrinhPhauThuat?.chuanDoanSauPTList
                )?.label
                  ? optionsIcd?.find(
                      (e) =>
                        e.value ===
                        patientDetail?.quaTrinhPhauThuat?.chuanDoanSauPTList
                    )?.label + " - "
                  : ""}
                {patientDetail?.quaTrinhPhauThuat?.chuanDoanSauPTValue} */}
              </Col>
            </Row>
            <Row>
              Phương pháp phẫu thuật/ thủ thuật:{" "}
              {listDmPPPT?.find(
                (e) =>
                  e.value === patientDetail?.quaTrinhPhauThuat?.ppPhauThuat ||
                  e.value === patientDetail?.dichVu
              )?.label || ""}
            </Row>
            <Row>
              {/* <Col span={12}> */}
              Loại phẫu thuật/ thủ thuật:{" "}
              {patientDetail?.quaTrinhPhauThuat?.loaiPhauThuatThuThuat}
              {/* </Col> */}
              {/* <Col span={12}>Phương pháp vô cảm: {ppVoCam?.label}</Col> */}
            </Row>
            <Row>Phương pháp vô cảm: {ppVoCam?.label}</Row>
            {/* <Row>Bác sĩ phẫu thuật/ thủ thuật chính: {surgeryDoctor?.name}</Row> */}
            <Row>
              <Col span={14}>
                Bác sĩ phẫu thuật/ thủ thuật chính: {surgeryDoctor?.name}
              </Col>
              {supportSurgeryDoctor2?.name ? (
                <Col span={10}>
                  Bác sĩ phẫu thuật/ thủ thuật phụ:{" "}
                  {supportSurgeryDoctor2?.name}
                </Col>
              ) : (
                <div></div>
              )}
            </Row>
            <Row>Bác sĩ gây mê hồi sức: {anesthesiologist?.name}</Row>

            <table
              style={{
                marginTop: "20px",
                width: "100%",
                border: "1px solid",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr>
                  <th
                    style={{
                      fontWeight: "bold",
                      width: "150px",
                      border: "1px solid",
                    }}
                  >
                    LƯỢC ĐỒ PHẪU THUẬT/ THỦ THUẬT
                  </th>
                  <th>TRÌNH TỰ PHẪU THUẬT/ THỦ THUẬT</th>
                </tr>
                <tr>
                  <td
                    style={{
                      minHeight: "300px",
                      position: "relative",
                      border: "1px solid",
                      height: "350px",
                      padding: "10px",
                    }}
                  >
                    <div style={{ position: "absolute", top: 10 }}>
                      <div style={{ display: "flex" }}>
                        <label className="custom-checkbox">
                          <input
                            onClick={() => setCheckedright(!checkedRight)}
                            checked={checkedRight}
                            type="checkbox"
                          />
                          <span></span>
                        </label>
                        <span
                          style={{ paddingLeft: "5px", paddingBottom: "8px" }}
                        >
                          Mắt phải
                        </span>
                      </div>
                      <div style={{ display: "flex", paddingBottom: "8px" }}>
                        <label className="custom-checkbox">
                          <input
                            onClick={() => setCheckedLeft(!checkedLeft)}
                            checked={checkedLeft}
                            type="checkbox"
                          />
                          <span></span>
                        </label>
                        <span style={{ paddingLeft: "5px" }}>Mắt trái</span>
                      </div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <ImageEyeSVG />
                    </div>
                  </td>
                  <td
                    className="text"
                    style={{
                      minHeight: "300px",
                      height: "fit-content",
                      whiteSpace: "pre-line",
                      verticalAlign: "top",
                      border: "1px solid",
                      padding: "10px",
                    }}
                  >
                    {patientDetail?.quaTrinhPhauThuat &&
                      getText(patientDetail?.quaTrinhPhauThuat?.moTa)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Sign
            nguoiThucHien={surgeryDoctor?.name ?? ""}
            label="PHẪU THUẬT/ THỦ THUẬT VIÊN"
            style={{
              textAlign: "end",
              marginTop: "36px",
            }}
            time={patientDetail?.quaTrinhPhauThuat?.thoiGianBatDau}
          />
        </div>
        <Row
          justify={"end"}
          gutter={[16, 16]}
          style={{ paddingTop: "10px", margin: "auto" }}
        >
          <Col>
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
          </Col>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            onAfterPrint={closeModal}
            bodyClass="phieu-pt"
          />
        </Row>
      </Spin>
    </div>
  );
};

export default PrintPhieuPT;
